import { createFileRoute } from '@tanstack/react-router'
import ProjectPage, { VALID_SECTION_IDS } from '../pages/ProjectPage/ProjectPage'
import { LEGACY_REPORT_TABS, REPORT_TABS, ReportTab } from '../components/ReportMetrics/ReportMetrics'
import { ProjectLoader } from '../components/loaders'

type ProjectSearchParams = {
  tab?: 'overview' | 'checkplan' | 'phase' | 'resource' | 'deliverables'
  section?: string
  taskId?: number
  /** Which Project Intelligence report page is open, so one can be linked to. */
  report?: ReportTab
  /** Open this object's detail in its section - the report's drill-down to the object itself. */
  deliverableId?: number
  checkpointId?: number
  actionPointId?: number
}

const positiveId = (value: unknown): number | undefined => {
  const id = Number(value)
  return Number.isFinite(id) && id > 0 ? id : undefined
}

const VALID_TABS = ['overview', 'checkplan', 'phase', 'resource', 'deliverables']

export const Route = createFileRoute('/project/$projectId')({
  component: ProjectPage,
  validateSearch: (search: Record<string, unknown>): ProjectSearchParams => {
    const tab = search.tab as string
    const section = search.section as string
    const taskId = Number(search.taskId)
    const report = search.report as string

    return {
      tab: (tab && VALID_TABS.includes(tab) ? tab : 'overview') as ProjectSearchParams['tab'],
      section: section && VALID_SECTION_IDS.has(section) ? section : undefined,
      taskId: Number.isFinite(taskId) && taskId > 0 ? taskId : undefined,
      report: REPORT_TABS.includes(report as ReportTab)
        ? (report as ReportTab)
        : LEGACY_REPORT_TABS[report],
      deliverableId: positiveId(search.deliverableId),
      checkpointId: positiveId(search.checkpointId),
      actionPointId: positiveId(search.actionPointId),
    }
  },
  pendingComponent: ProjectLoader,
})
